module.exports = __webpack_public_path__ + "static/img/5927_phase_function_Paper_Points.4341850.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5927_phase_function_Paper_Points.png
// module id = 2ZOC
// module chunks = 0